import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Home from '@/views/Home';
import EventBus from './events/EventBus';
import Auth from '@aws-amplify/auth';

Vue.use(Router);
console.log('Collaing get user from main');
//getUser();

EventBus.$on('authState', async state => {
  console.log('Auth state cnahed to ' + state);
  if (state === 'signedOut') {
    store.dispatch('awsauth/setUser', null);
    console.log('Redirecting to login because of signed out');
    router.push({ path: '/auth' });
  } else if (state === 'signedIn') {
    await getUser(); //oggiorno lo store con l'utente corrente in modo che tutti possano usufruirne
    console.log('Redirecting to home because of signed in');
    //router.push({ path: '/' });
    router.push(router.currentRoute.query.redirect || '/');
  }
});

function getUser() {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      if (user && user.signInUserSession) {
        store.dispatch('awsauth/setUser', user);
        return user;
      }
    })
    .catch(e => {
      console.log(e);
      store.dispatch('awsauth/setUser', null);
      return null;
    });
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/gw/:id',
      name: 'gateway',
      component: () => import('./components/Gateway.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/incoming/:id',
      name: 'incoming',
      component: () => import('./components/Gateway.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import('./views/Calls.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/call/:uuid',
      name: 'call',
      component: () => import('./components/CallPage.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
      meta: {
        signedInDenied: true
      }
    },
    {
      path: '/handle',
      beforeEnter: to => {
        console.warn('Handle incomin call', to.query);
        store.dispatch('signalling/setPush', to.query);
      },
      meta: {
        authRequired: true
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('./views/Invite.vue'),
      meta: {
        authRequired: true
      }
    }
  ]
});

router.beforeResolve(async (to, from, next) => {
  //console.log(to);
  console.log('Resolving from ' + from.fullPath + ' to ' + to.fullPath);
  if (to.matched.some(record => record.meta.authRequired)) {
    console.log('Because of the page requires auth');
    let user = await getUser();
    console.log('Going to check user', user);
    if (!user) {
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      });
    }
    return next();
  } else if (to.matched.some(record => record.meta.signedInDenied)) {
    let user = await getUser();
    console.log('Going to check user', user);
    if (user) {
      return next({
        path: '/'
      });
    }
    return next();
  }
  return next();
});

export default router;
